export default {
  GARAGE: "Garages",
  NOTARY: "Notarissen",
  EXPERT: "Experts",
  ESTATE_AGENT: "Makelaar",
  // PURCHASING_BROKER: "Aankopend makelaar",
  LENDER: "Geldverstrekker",
  STRUCTURAL_ENGINEER: "Bouwkundig ingenieur",
};
